import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import ModalSolicitud from '../../components/ModalPersonalizado/ModalSolicitud';

const columns = [
    {
        label: "Código Solicitud",
        field: "id",
        sort: "asc"
    },
    {
        label: "Nombre",
        field: "titulo",
        sort: "asc"
    },
    {
        label: "Fecha de Solicitud",
        field: "fecha_creacion_str",
        sort: "asc"
    },
    {
        label: "Prioridad",
        field: "prioridad_nombre",
        sort: "asc"
    },
    /*  
        label: "Tipo Solicitud",
        field: "tipo_solicitud_nombre",
        sort: "asc"
    } */
    {
        label: "Fecha Programada",
        field: "fecha_programada_str",
        sort: "asc"
    },
    {
        label: "Asignado a",
        field: "colaborador_nombre",
        sort: "asc"
    },
    {
        label: "Ubicación",
        field: "lugar_ubicacion_nombre",
        sort: "asc"
    },
    {
        label: "Departamento / Área",
        field: "asignado_a_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    },
    {
        label: "Acciones",
        field: "accion",
        width: 100
    }
];
export default class SolicitudListado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.solicitud = 'ADMINISTRAR';
        this.titulo = 'Administrador de Solicitudes';
        this.hoy = new Date()       
        this.fechaToday = this.formatoFecha(this.hoy)
        this.fechaAtras = this.formatoFecha(new Date(this.hoy.getFullYear(), this.hoy.getMonth(), this.hoy.getDate() - 7))
        this.pathname = this.props.location.pathname

        switch (this.props.location.pathname) {
            case '/solicitudNueva':
                this.solicitud = 'NUEVA';
                this.titulo = 'Mis Solicitudes Enviadas';
                break;
            case '/solicitudAsignar':
                this.solicitud = 'ASIGNAR_PLANIFICAR';
                this.titulo = 'Asignar Planificar Solicitud';
                break;
            case '/solicitudConcluir':
                this.solicitud = 'CONCLUIR';
                this.titulo = 'Concluir Solicitud';
                this.fechaToday = undefined
                this.fechaAtras = undefined
                break;
            case '/solicitudCalificar':
                this.solicitud = 'CALIFICAR';
                this.titulo = 'Calificar Solicitud';
                break;
            case '/solicitudFinalizada':
                this.solicitud = 'FINALIZADA';
                this.titulo = 'Solicitudes Finalizadas';
                break;
            case '/solicitudDelDepartamento':
                this.solicitud = 'DEL_DEPARTAMENTO';
                this.titulo = 'Solicitudes Enviadas por el Departamento';
                break;
            case '/solicitudArchivado':
                this.solicitud = 'ARCHIVADO';
                this.titulo = 'Solicitudes Archivadas';
                break;
        }

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,
            idRegistroEliminar: undefined,
            ubicaciones: [],
            departamentosAreas: [],
            tiposSolicitudes: [],
            lista: [],

            filtros: {
                fechaMin: this.fechaAtras,
                fechaFin: this.fechaToday,
                lugar_ubicacion: undefined,
                solicitar_a: undefined,
                tipo_solicitud: undefined,
                usuario: undefined,
                empresa: undefined,
                solicitud_id: undefined,
                estado: undefined,
            }
        }
    }

    componentDidMount() {
        this.cargarValoresFiltros();
        /*let filtros_anteriores = JSON.parse(localStorage.getItem("filtros_"+this.solicitud));
        if (filtros_anteriores) {  
            this.setState({ filtros: filtros_anteriores });
            this.setState({ mostrarSpinner: true });
            if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR'|| this.solicitud == 'CONCLUIR' ) {
                filtros_anteriores.solicitud = this.solicitud;
                filtros_anteriores.usuario = this.apiRest.getLS('du').colaborador.id;                
                this.apiRest.put('/misSolicitudes', filtros_anteriores).then(respuesta => {
                    if (respuesta.exitoso) { 
                        this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                        this.setState({ mostrarSpinner: false});
                    }
                });
            } else {
                filtros_anteriores.solicitud = this.solicitud;
                this.apiRest.post('/solicitudesFiltradas', filtros_anteriores).then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                        this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                        this.setState({ mostrarSpinner: false});
                    }
                });
            }*/
            //this.filtros = this.filtros_anteriores;
            /*this.setState(estadoAnterior => ({
                filtros: { ...estadoAnterior.filtros, ...filtros_anteriores }
            }));  */      
            /*this.apiRest.post('/busquedaFiltradaSolicitud', filtros_anteriores ).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                    this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                }
            });*/
        /*} else {*/
            if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR' || this.solicitud == 'CONCLUIR' || this.solicitud == 'DEL_DEPARTAMENTO' ) {
                this.revisarMisSolicitudes();
            } else {
                if (this.apiRest.getRol() || this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) {
                    //this.buscar();
                    this.setState({ mostrarSpinner: false});
                    toastr.warning('Ingrese los valores de búsqueda');
                } else {
                    this.revisarMisSolicitudes();            
                }
            }
        /*}*/        
        
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoDepartamento = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoDepartamento2 = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelectUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));
    formatoSolicitud = valores => valores.data.map(i => ({ value: i.id, label: i.id + '->' + i.titulo }));

    cargarValoresFiltros = () => {

        if (this.solicitud == 'CALIFICAR') {
            if (this.apiRest.getRol()) {
                this.apiRest.get('/departamentoArea').then(resultado => {
                    if (resultado.exitoso) {
                        this.setState({ departamentosAreas: this.formatoDepartamento(resultado) });
                    }
                })
            } else {
                this.apiRest.getUbicacion('/getDepartamentoArea/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ departamentosAreas: this.formatoDepartamento(respuesta) });
                    }
                });
            }

        } else if (this.solicitud == 'DEL_DEPARTAMENTO') {
            this.apiRest.get('/departamentoArea').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentosAreas: this.formatoDepartamento(resultado) });
                }
            })
        } else {
            this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
                if (resultado.exitoso) {
                    //console.log(resultado);
                    this.setState({ departamentosAreas: resultado.data });
                }
            });
        }
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelectUbicacion(resultado) });
            }
        });
        /*if (this.apiRest.getRol()) {
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoSelectUbicacion(resultado) });
                }
            });
        } else {
            if (_valid(this.apiRest.getLS('idEmpresa'))) {
                this.apiRest.getUbicacion('/getUbicacion/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ ubicaciones: this.formatoSelectUbicacion(respuesta) });
                    }
                });
            }
        }*/
    }

    obtenerTipoSolicitud(departamentoArea) {
        if (departamentoArea) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + departamentoArea.value).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tiposSolicitudes: this.formatoSelect(resultado) });
                }
            });
        } else {
            this.setState({ tiposSolicitudes: [] });
        }
    }

    editarRegistroRedireccionar = registro => {
        this.props.history.replace({ pathname: '/solicitud', registro: registro });
    }

    eliminarRegistro = idRegistro => {
        this.apiRest.delete('/solicitud/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Registro eliminado exitosamente!');
                this.ocultarModalEliminar();
                this.buscar();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: value }
        }));
    }

    actualizarValoresNumericos = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: parseInt(value) }
        }));
    }

    setDepartamentoArea = departamentoArea => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['solicitar_a']: departamentoArea }
        }));

        this.obtenerTipoSolicitud(departamentoArea);
        this.listaSolicitudes(departamentoArea);
    }

    setTipoSolicitud = tipoSolicitud => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['tipo_solicitud']: tipoSolicitud }
        }));
    }

    setUbicacion = ubicacion => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['lugar_ubicacion']: ubicacion }
        }));
    }

    botonesListado = (registro, indicador) => {
        switch (this.solicitud) {
            case 'NUEVA':
                return (
                    (registro.estado == 3) ?
                        <ModalSolicitud titulo="Calificar" color="warning" icon="fas fa-star" rol="calificar" 
                        idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                    :   <ModalSolicitud titulo="Consultar" color="secondary" icon="far fa-eye" rol="finalizada" 
                        idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                )                 
                {/*(
                    <MDBBtn className="waves-effect" size="sm" color="secondary" title="Consultar" onClick={() => this.props.history.replace({ pathname: '/solicitud', rol: "finalizada", idRegistro: registro.id, pathnameAnterior: this.pathname })}>
                        <MDBIcon icon="far fa-eye" />
                    </MDBBtn>
                )*/}             
            case 'ASIGNAR_PLANIFICAR':
                return (
                    <MDBBtn className="waves-effect" size="sm" color="info" title="Asignar proyecto / colaborador" onClick={() => this.props.history.replace({ pathname: '/solicitud', rol: "asignar_proyecto", idRegistro: registro.id, pathnameAnterior: this.pathname })}>
                        <MDBIcon icon="fas fa-project-diagram" />
                    </MDBBtn>
                )
            case 'CONCLUIR':
                return (
                    ((registro.estado >= 0 && registro.estado <=2) || registro.estado == 6 || registro.estado == 7 ) ?
                        <ModalSolicitud titulo="Concluir" color="success" icon="fas fa-check" rol="tarea_realizado"
                        idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                    : ''
                )
            case 'CALIFICAR':
                return (
                    <ModalSolicitud titulo="Calificar" color="warning" icon="fas fa-star" rol="calificar" 
                    idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                )
            case 'FINALIZADA':
                return (
                    <ModalSolicitud titulo="Consultar" color="secondary" icon="far fa-eye" rol="finalizada" 
                    idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                )
            case 'ADMINISTRAR':
                return [
                    (
                        <ModalSolicitud titulo="Consultar" color="secondary" icon="far fa-eye" rol="finalizada" 
                        idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                    )
                    , ' ',
                    (
                        (registro.estado >= 0 && registro.estado <=2 ) ?
                            <ModalSolicitud titulo="Asignar proyecto / colaborador" color="info" icon="fas fa-project-diagram" rol="asignar_proyecto"
                            idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                        : ''
                    )
                    /*, ' ',
                    (
                        <MDBBtn className="waves-effect" size="sm" color="secondary" title="Consultar" onClick={() => this.props.history.replace({ pathname: '/solicitud', rol: "finalizada", idRegistro: registro.id, pathnameAnterior: this.pathname })}>
                            <MDBIcon icon="far fa-eye" />
                        </MDBBtn>
                    )
                    , ' ',                    
                    (
                        (registro.estado >= 0 && registro.estado <=2 ) ?
                            <MDBBtn className="waves-effect" size="sm" color="info" title="Asignar proyecto / colaborador" onClick={() => this.props.history.replace({ pathname: '/solicitud', rol: "asignar_proyecto", idRegistro: registro.id, pathnameAnterior: this.pathname })}>
                                <MDBIcon icon="fas fa-project-diagram" />
                            </MDBBtn>
                        : ''
                    )
                    , ' ',
                    (
                        <MDBBtn className="waves-effect" size="sm" color="danger" title="Eliminar" onClick={() => this.mostrarModalEliminar(registro.id)}>
                            <MDBIcon icon="fas fa-times" />
                        </MDBBtn>
                    )*/
                ];
            case 'DEL_DEPARTAMENTO':
                return (
                    <ModalSolicitud titulo="Consultar" color="secondary" icon="far fa-eye" rol="finalizada" 
                    idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                ) 
            case 'ARCHIVADO':
                return (
                    <ModalSolicitud titulo="Consultar" color="secondary" icon="far fa-eye" rol="finalizada" 
                    idRegistro={registro.id} actualizarFila={this.actualizarFila}/>
                ) 
            default:
                break
        }
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => [
            registro.titulo = (registro.titulo != "") ? registro.titulo : registro.descripcion.substring(0, 35), 
            registro.accion = this.botonesListado(registro)
        ]);
        return { columns, rows };
    };

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: undefined });
    }

    realizarConsulta = () => {
        this.buscar();
    }

    buscar = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        this.setState({ mostrarSpinner: true });
        //if (this.apiRest.getRol()) {
        this.apiRest.post('/solicitudesFiltradas', filtros).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                this.obtenerTipoSolicitud(this.state.filtros.solicitar_a);
                this.setState({ mostrarSpinner: false }); 
            }
        });
        /*} else {
            let userEmpresa = undefined;
            let usuario = undefined;
            userEmpresa = this.apiRest.getLS('idEmpresa');

            usuario = this.apiRest.getLS('du');

            if (_valid(userEmpresa)) {
                filtros.empresa = userEmpresa.id
                if (_valid(usuario)) {
                    filtros.usuario = usuario.colaborador.id
                    //console.log(filtros)
                    this.apiRest.post('/solicitudesFiltradas', filtros).then(respuesta => {
                        if (respuesta.exitoso) {
                            this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                        }
                    });
                }
            }
        }*/
    }

    validarFiltros = () => {
        const {
            filtros
        } = this.state

        if (_valid(filtros.fechaMin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Fin.');
                return false
            }
        }

        if (_valid(filtros.fechaFin)) {
            if (_valid(filtros.fechaMin) && _valid(filtros.fechaFin)) {
                return true
            } else {
                toastr.error('Fecha no valida falta seleccionar Fecha Inicio.');
                return false
            }
        }

        return true;
    }

    camposFiltros = () => {
        const {
            filtros
        } = this.state;
        let contador = 0;
        for (let i in filtros) {
            if (_valid(filtros[i])) {
                //console.log(filtros[i])
                contador++;
            }
        }
        if (contador > 1) {
            return true;
        } else {
            this.apiRest.getRol() ? toastr.error('Seleccione una opcion para realizar una Busqueda.')
                : toastr.error('Seleccione un Departamento u Área primero');
            return false;
        }
    }

    filtrarBusqueda = () => {
        const {
            filtros
        } = this.state
        filtros.solicitud = this.solicitud;
        //localStorage.setItem("filtros_"+this.solicitud, JSON.stringify(filtros));

        //if (this.camposFiltros()) {
            //if (this.apiRest.getRol()) {
                if (this.validarFiltros()) {
                    if ( this.solicitud == 'NUEVA'|| this.solicitud == 'CALIFICAR'|| this.solicitud == 'CONCLUIR' || this.solicitud == 'DEL_DEPARTAMENTO' ) {
                        this.revisarMisSolicitudes();
                    } else {
                        if (this.apiRest.getRol() || this.apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO')) {
                            this.buscar();
                        } else {
                            this.revisarMisSolicitudes();            
                        }
                    }
                    
                    /*this.setState({ mostrarSpinner: true });
                    this.apiRest.post('/busquedaFiltradaSolicitud', filtros).then(respuesta => {
                        if (respuesta.exitoso) {
                            this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                        }
                    });*/
                }
            /*} else {
                let userEmpresa = undefined;
                let usuario = undefined;
                userEmpresa = this.apiRest.getLS('idEmpresa');

                usuario = this.apiRest.getLS('du');
                if (_valid(filtros.solicitar_a)) {
                    if (this.validarFiltros()) {
                        this.setState({ mostrarSpinner: true });
                        filtros.empresa = userEmpresa.id
                        if (_valid(usuario)) {
                            filtros.usuario = usuario.colaborador.id
                            this.apiRest.post('/busquedaFiltradaSolicitud', filtros).then(respuesta => {
                                if (respuesta.exitoso) {
                                    //console.log(respuesta.data)
                                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                                }
                            });
                        }
                    }
                } else {
                    toastr.error('Debe elegir un Departamento.');
                }
            }*/
        //}
    }

    actualizarFila = (idRegistro) => {
        this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                const indiceElemento = this.state.tabla.rows.findIndex(el => el.id == idRegistro);
                let newTodos = [...this.state.tabla.rows]
                newTodos[indiceElemento] = {...resultado.data, accion: this.botonesListado(resultado.data)} 
                this.setState(estadoAnterior => ({
                    tabla: { ...estadoAnterior.tabla, rows: newTodos }
                }));
                console.log(this.state.tabla.rows)
            }
        });
    }

    revisarMisSolicitudes = () => {
        const {
            filtros
        } = this.state

        filtros.solicitud = this.solicitud;
        filtros.usuario = this.apiRest.getLS('du').colaborador.id;
        this.setState({ mostrarSpinner: true });       
        this.apiRest.put('/misSolicitudes', filtros).then(respuesta => {
            if (respuesta.exitoso) {                
                this.setState({ tabla: this.agregarAccionesRegistro(respuesta.data) });
                this.setState({ mostrarSpinner: false });
            }
        });
    }

    limpiarCampo = (name) => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, [name]: null }
        }));
    }

    limpiar = () => {        
        //localStorage.removeItem("filtros_"+this.solicitud);
        
        this.setState({
            filtros: {
                fechaMin: '',
                fechaFin: '',
                lugar_ubicacion: '',
                solicitar_a: '',
                tipo_solicitud: '',                
                solicitud_id: '',
                estado: '',
            },
            tabla: { columns: columns, rows: [] },
        });
    }

    listaSolicitudes = (idDepartamento) => {
        if (idDepartamento) {
            let filtros = {};
            filtros = {
                departamento: idDepartamento.value,
                estado: this.tipoDeEstado(this.solicitud),
            }

            this.apiRest.post('/solicitudNumero', filtros).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({
                        lista: this.formatoSolicitud(respuesta)
                    })
                }
            });
        } else {
            this.setState({ lista: [] });
            this.limpiarCampo('solicitud_id');
        }
    }

    tipoDeEstado = (estado) => {
        let esato = [];
        switch (estado) {
            case 'ADMINISTRAR':
                estado = [0,1,2,3,4,5];
                break;
            case 'NUEVA':
                estado = [0];
                break;
            case 'ASIGNAR_PLANIFICAR':
                estado = [0];
                break;
            case 'CONCLUIR':
                estado = [1,2,6];
                break;
            case 'CALIFICAR':
                estado = [3,5];
                break;
            case 'FINALIZADA':
                estado = [3,4];
                break;
        }

        return estado;
    }

    setSolicitud = solicitud => {
        this.setState(estadoAnterior => ({
            filtros: { ...estadoAnterior.filtros, ['solicitud_id']: solicitud }
        }));
    }

    formatoFecha(fecha) {
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let anio = fecha.getFullYear();
        if (dia < 10) {
            dia = '0' + dia;
        }
        if (mes < 10) {
            mes = '0' + mes;
        }
        return anio + '-' + mes + '-' + dia;
    }

    quitarDias(date, days) {
        const dateCopy = new Date(date);
        dateCopy.setDate(date.getDate() - days);
        return dateCopy;
    }

    render() {
        const {
            mostrarSpinner,
            tabla,
            modalAbierto,
            idRegistroEliminar,
            filtros,
            ubicaciones,
            departamentosAreas,
            tiposSolicitudes,
            lista
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem={this.titulo} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        {
                                            (this.solicitud == 'ADMINISTRAR' || this.solicitud == 'NUEVA') ? (
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.props.history.replace({ pathname: '/solicitud', pathnameAnterior: this.pathname })} disabled={true}>
                                                    <MDBIcon icon="fas fa-clipboard" />{' '}
                                                    Nueva
                                                </MDBBtn>)
                                                : ""
                                        }

                                        <br /><br />
                                        
                                        <div>
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaInicio" className="form-label">
                                                        Fecha Inicio
                                                    </Label>
                                                    <Input
                                                        name="fechaMin"
                                                        value={filtros.fechaMin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaFin" className="form-label">
                                                        Fecha Fin
                                                    </Label>
                                                    <Input
                                                        name="fechaFin"
                                                        value={filtros.fechaFin}
                                                        onChange={this.actualizarValores}
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="solicitar_a" className="form-label">
                                                        Departamento / Área
                                                    </Label>
                                                    <Select
                                                        name="solicitar_a"
                                                        options={departamentosAreas}
                                                        value={filtros.solicitar_a}
                                                        onChange={this.setDepartamentoArea}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="tipo_solicitud" className="form-label">
                                                        Tipo de solicitud
                                                    </Label>
                                                    <Select
                                                        name="tipo_solicitud"
                                                        options={tiposSolicitudes}
                                                        value={filtros.tipo_solicitud}
                                                        onChange={this.setTipoSolicitud}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "Debe seleccionar un Departamento u Área para mostrar los tipo de solicitudes"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="lugar_ubicacion" className="form-label">
                                                        Ubicaci&oacute;n
                                                    </Label>
                                                    <Select
                                                        name="lugar_ubicacion"
                                                        options={ubicaciones}
                                                        value={filtros.lugar_ubicacion}
                                                        onChange={this.setUbicacion}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                {
                                                    (this.solicitud == 'ADMINISTRAR' || this.solicitud == 'DEL_DEPARTAMENTO' || this.solicitud == 'NUEVA') ? (
                                                        <Col lg={3}>
                                                            <Label className="form-label">
                                                                Estado:
                                                            </Label>
                                                            <select
                                                                value={filtros.estado}
                                                                onChange={this.actualizarValoresNumericos}
                                                                name="estado"
                                                                className="form-control"
                                                            >
                                                                <option key={''} value={''}></option>
                                                                <option key={0} value={0}>No asignado</option>
                                                                <option key={1} value={1}>Asignado</option>
                                                                <option key={2} value={2}>Planificado</option>
                                                                <option key={6} value={6}>En proceso</option>
                                                                <option key={3} value={3}>Concluido</option>
                                                                <option key={4} value={4}>Aceptado</option>                                                               
                                                                <option key={5} value={5}>Rechazado</option>
                                                            </select>
                                                        </Col>)
                                                    : ""
                                                }
                                                <Col lg={3}>
                                                    <Label htmlFor="solicitud_id" className="form-label">
                                                        Número de solicitud
                                                    </Label>
                                                    <Select
                                                        name="solicitud_id"
                                                        options={lista}
                                                        value={filtros.solicitud_id}
                                                        onChange={this.setSolicitud}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Seleccionar"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={12}>
                                                    <MDBBtn className="waves-effect" color="info" onClick={this.filtrarBusqueda}>
                                                        <MDBIcon icon="fas fa-search" />{' '}
                                                        BUSCAR
                                                    </MDBBtn>
                                                    <MDBBtn className="waves-effect float-end" color="danger" onClick={this.limpiar}>
                                                        Borrar Filtros
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </div>
                                            
                                        <p />
                                        {
                                            mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable
                                                keyField="id"
                                                hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]}
                                                noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]}
                                                entriesLabel="Mostrando entradas" data={tabla}
                                                disableRetreatAfterSorting={true}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Solicitud
                    </ModalHeader>
                    <ModalBody>
                        Esta segur@?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.eliminarRegistro(idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}